// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0098adef","738":"002f5735","974":"4f6e1c59"}[chunkId] + ".chunk.js";
};